import { merge } from 'lodash';

import appConfig from '../appConfig';
import { dispatchUnauthorizedApi } from '../utils/eventDispatchers';
import { getJwt } from '../utils/jwt';

const defaultApiErrorMessage = 'An error occurred, please try again or contact our Customer Service.';

const baseApi = appConfig.portal.apiUrl;
const baseRequestParams: RequestInit = {
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		'X-Platform': 'web',
		'X-Product': window.location.hostname,
	},
	method: 'GET',
};

const remote = async (endpoint: string, params?: RequestInit) => {
	const jwt = getJwt();
	const requestParams = merge(
		{
			headers: {
				Authorization: jwt && `Bearer ${jwt}`,
			},
		},
		baseRequestParams,
		params
	);

	return fetch(`${baseApi}${endpoint}`, requestParams);
};

export const remoteBlob = async (endpoint: string, params?: RequestInit) => {
	const response = await remote(endpoint, params);

	if (!response.ok) throw response;

	return response.blob();
};

export const remoteJSON = async (endpoint: string, params?: RequestInit, includeResponseHeaders?: Array<string>) => {
	const response = await remote(endpoint, params);
	const jsonResponse = (await response.json()) as APIResponse;

	if (jsonResponse.errors) {
		if (response.status === 401) {
			// This will notify PortalSessionContext that the jwt token was not accepted and trigger
			// a logout or attempt to refresh in case it's in the expired state
			dispatchUnauthorizedApi(jsonResponse as UnauthorizedResponse);
		}
		throw jsonResponse;
	}

	if (!response.ok) {
		const errorResponse = {
			errors: {
				error: [defaultApiErrorMessage],
			},
			original_response: response,
		};
		throw errorResponse;
	}

	if (includeResponseHeaders) {
		const responseHeaders = {};
		includeResponseHeaders.forEach((header) => (responseHeaders[header] = response.headers.get(header)));

		return {
			...jsonResponse,
			__headers: responseHeaders,
		};
	}

	return jsonResponse;
};
